<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>

        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <customers-overview :tableData="customers" @giveAccess="giveAccess" />
            </div>
        </div>
    </div>
</template>

<script>
import { customerMixin, CustomersOverview, CustomersApi } from 'relapp-customers';
import { apiMixin } from 'relapp-api';
import { EventBus } from 'relapp-event';
import { canHaveCustomersPageMixin } from 'relapp-auth';

export default {
    components: {
        CustomersOverview
    },
    metaInfo: {
        title: trans('page.customers.title')
    },
    mixins: [customerMixin, apiMixin, canHaveCustomersPageMixin],
    methods: {
        /**
         * Give the customer access to the app.
         *
         * @param {object} customer
         */
        giveAccess(customer) {
            this.startLoading();

            CustomersApi.giveAccess(customer)
                .then(() => {
                    this.finishLoading();
                    this.getCustomers();

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('customer.confirmation.message')
                    });
                })
                .catch(this.showValidationNotification)
                .then(this.finishLoading);
        }
    }
};
</script>
